
const INIT_STATE = {
	cashBack:{},
  productCount: 1
};


export default (state = INIT_STATE, action) =>{
    switch(action.type) {
        case 'cashBack':
          state.cashBack = action.payload.profits;
        return {...state};

        case 'productCount':
          state.productCount = action.payload.productCount;
        return {...state};

        default:
      return { ...state };
    }
}